enum ApiNotifMsgType {
    Dico = 'dicoUpdate',
    Data = 'data'
};

export default ApiNotifMsgType;